// @flow
import React, { Children, Component, type Element, type Node } from 'react';

import ResponsiveContext from 'Components/utils/responsive/responsiveContext';

import { Slider } from 'Components/frameworks/slider/Slider.jsx';

export type ProductInformationSliderProps = {
  children: Node,
  isLarge?: boolean,
  queryLayer: string,
  scrollBackwardLabel?: string,
  scrollForwardLabel?: string,
  toggleLayer: (number, boolean) => void,
};

type State = {};

export class ProductInformationSlider extends Component<ProductInformationSliderProps, State> {
  static contextType = ResponsiveContext;

  openLayer = (activeItem: number) => this.props.toggleLayer(activeItem, true);

  shouldComponentUpdate() {
    return false;
  }

  render() {
    const { children, isLarge, queryLayer, scrollBackwardLabel, scrollForwardLabel } = this.props;

    if (!Children.count(children)) return null;

    const { isDesktop, isTablet } = this.context;

    const renderItem = (element: Element<*>, index: number) => {
      let { link = {} } = element.props;
      if (!link.url) {
        link = { ...link, onClick: () => this.openLayer(index) };
      }

      return React.createElement(
        'div',
        { style: { width: !isTablet ? 280 : null } },
        React.cloneElement(element, { link, isLarge }),
      );
    };

    const getCols = () => {
      if (isTablet) {
        if (isLarge) return 2;
        if (isDesktop) return 4;
        return 3;
      }
      return 0;
    };

    const clonedChildren = Children.map(children, renderItem);

    return (
      <section>
        <Slider
          cols={getCols()}
          hasControls={isTablet}
          id={queryLayer}
          navPosition={isTablet ? 'top' : 'center'}
          nbItemsToScroll={isTablet ? 2 : 1}
          nextLabel={scrollForwardLabel}
          previousLabel={scrollBackwardLabel}
          scrollAreaClassName="overflow-hidden -mx-2"
          scrollAreaContainerClassName="overflow-auto scroll-snap-area scroll-snap-type-x-mandatory"
          scrollItemClassName="overflow-hidden px-2 flex-none max-w-full"
        >
          {clonedChildren}
        </Slider>
      </section>
    );
  }
}
